var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVipCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40662",
    "data-name": "Group 40662",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15504",
    "data-name": "Rectangle 15504",
    width: 40,
    height: 40,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vip",
    transform: "translate(2.75 2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36973",
    "data-name": "Path 36973",
    d: "M32.824,20.349l.367,3.5L30.452,26.07l-1,3.377-3.377,1-2.218,2.738-3.5-.367L17.25,34.5l-3.1-1.676-3.5.367L8.43,30.452l-3.377-1-1-3.377L1.309,23.853l.367-3.5L0,17.25l1.676-3.1-.367-3.5L4.048,8.43l1-3.377,3.377-1,2.218-2.738,3.5.367L17.25,0l3.1,1.676,3.5-.367L26.07,4.048l3.377,1,1,3.377,2.738,2.218-.367,3.5,1.676,3.1Z",
    transform: "translate(0 0)",
    fill: "#fcdb6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36975",
    "data-name": "Path 36975",
    d: "M303.5,274.343h-2.256V263.778h3.393a3.393,3.393,0,0,1,0,6.786H303.5Zm0-6.034h1.137a1.137,1.137,0,0,0,0-2.275H303.5Z",
    transform: "translate(-281.454 -246.783)",
    fill: "#202f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36976",
    "data-name": "Path 36976",
    d: "M241,263.77h2.256v10.566H241Z",
    transform: "translate(-224.878 -246.776)",
    fill: "#3e4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36977",
    "data-name": "Path 36977",
    d: "M256,263.77h1.128v10.566H256Z",
    transform: "translate(-238.81 -246.776)",
    fill: "#202f51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36978",
    "data-name": "Path 36978",
    d: "M121.593,276.587h-1.848l-2.813-9.758,2.168-.625,1.569,5.443,1.569-5.443,2.168.625Z",
    transform: "translate(-109.273 -249.035)",
    fill: "#3e4677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36979",
    "data-name": "Path 36979",
    d: "M197.046,108.933l-.866,7.653h-8.7l-.866-7.653,3.129,1.967,2.089-3.18,2.089,3.18Z",
    transform: "translate(-174.578 -100.713)",
    fill: "#f82a4f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipCustomerIcon);
export default __webpack_public_path__ + "static/media/vip-customer-icon.5fc56250b672855e1728676ef3343cfe.svg";
export { ForwardRef as ReactComponent };